module.exports = __webpack_public_path__ + "0557eb32899dc62ffb71ff6ae1ec912a.svg";